const handleOveride = () => {
  if (!BSS_B2B?.qb) return;

  BSS_B2B.qb.totalPriceOfItemElement = function (key) {
    return ['[bss-b2b-cart-item-key="' + key + '"][bss-b2b-final-line-price]'];
  };
};

const parseMoney = (value) => {
  if (!value) return 0;

  const matches = String(value).match(/-?\d[\d,]*(?:\.\d+)?/g);
  if (!matches?.length) return 0;

  return parseFloat(matches[matches.length - 1].replace(/,/g, '')) || 0;
};

const formatMoney = (amount) => {
  const currency = window.Shopify?.currency?.active || 'USD';

  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(amount);
};

const getCartItemFinalPriceElement = (item) => {
  return (
    item.querySelector(
      '.cart-item__price-wrapper .price.price--end:not(.cart-item__old-price) [bss-b2b-final-line-price]'
    ) || item.querySelector('.cart-item__price-wrapper > .price.price--end [bss-b2b-final-line-price]')
  );
};

let applyingCorrectTotal = false;
let updateTimer;

const applyCorrectCartTotal = async () => {
  if (applyingCorrectTotal) return;

  const totalElements = document.querySelectorAll('[bss-b2b-cart-total-price]');
  if (!totalElements.length) return;

  applyingCorrectTotal = true;

  try {
    let formattedTotal = '';

    if (document.body.classList.contains('is_b2b')) {
      let total = 0;

      document.querySelectorAll('.cart-item').forEach((item) => {
        const priceElement = getCartItemFinalPriceElement(item);
        if (priceElement) total += parseMoney(priceElement.textContent);
      });

      if (total <= 0) return;
      formattedTotal = formatMoney(total);
    } else {
      const cart = await fetch('/cart.js').then((response) => response.json());
      if (!cart.item_count) return;
      formattedTotal = formatMoney(cart.total_price / 100);
    }

    totalElements.forEach((element) => {
      if (element.textContent.trim() !== formattedTotal) {
        element.textContent = formattedTotal;
      }
      element.style.visibility = 'visible';
    });
  } catch (error) {
    console.warn('Cart total update failed', error);
  } finally {
    applyingCorrectTotal = false;
  }
};

const scheduleCartTotalUpdate = () => {
  clearTimeout(updateTimer);
  updateTimer = setTimeout(() => {
    applyCorrectCartTotal();
    setTimeout(applyCorrectCartTotal, 250);
    setTimeout(applyCorrectCartTotal, 1000);
    setTimeout(applyCorrectCartTotal, 2500);
  }, 0);
};

const observeCartTotals = () => {
  document.querySelectorAll('[bss-b2b-cart-total-price]').forEach((element) => {
    if (element.dataset.totalObserverAttached === 'true') return;

    element.dataset.totalObserverAttached = 'true';

    new MutationObserver(() => {
      if (!applyingCorrectTotal) scheduleCartTotalUpdate();
    }).observe(element, { childList: true, characterData: true, subtree: true });
  });
};

const initCartTotalFix = () => {
  handleOveride();
  observeCartTotals();
  scheduleCartTotalUpdate();
};

const bssInitInterval = setInterval(() => {
  if (window.BSS_B2B?.qb?.priceOfEachItemElement) {
    initCartTotalFix();
    clearInterval(bssInitInterval);
  }
}, 100);

setTimeout(() => clearInterval(bssInitInterval), 10000);

document.addEventListener('DOMContentLoaded', () => {
  initCartTotalFix();
});

const getBssStoreData = () => {
  const storeDataNode = document.getElementById('bss-b2b-store-data');
  if (!storeDataNode) return null;

  const rawStoreData = (storeDataNode.textContent || '').trim();
  if (!rawStoreData) return null;

  try {
    return JSON.parse(rawStoreData);
  } catch (error) {
    console.warn('BSS store data JSON parse failed', error);
    return null;
  }
};

window.addEventListener('cart_changed', () => {
  const storeData = getBssStoreData() || BSS_B2B.shopData;

  if (storeData && BSS_B2B?.cart?.fixer) {
    BSS_B2B.cart.fixer(storeData, false, false);
  }

  if (BSS_B2B?.handleCartCheckoutBtn) {
    BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData);
  }

  observeCartTotals();
  scheduleCartTotalUpdate();
});

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    observeCartTotals();
    scheduleCartTotalUpdate();
  });
}

new MutationObserver(() => {
  observeCartTotals();
}).observe(document.body, { childList: true, subtree: true });

window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};
window.BSS_B2B = window.BSS_B2B || {};
window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};
const handleCartCheckoutBtn = ({ shopData, checkoutButton, Tax }) => {
  const defaultBtnCheckout = $(checkoutButton).parent().find("button[name='checkout']:not(.bss-checkout)");
  if (defaultBtnCheckout.length > 0 && $(checkoutButton).parent().find('.bss-checkout').length) {
    defaultBtnCheckout.css('display', 'none');
    $('.bss-checkout').css('display', 'flex');
  }
};
window.BSS_B2B.addAction('fix_handle_cart_checkout_btn', handleCartCheckoutBtn);

setTimeout(() => {
  document.querySelectorAll('.cart__checkout-button').forEach((item) => {
    item.style.opacity = '1';
    item.style.pointerEvents = 'unset';
  });
}, 4000);
